export type VolumePage = {
  src: string
  caption: string
}

/** Real Volume 1 pages, 1080×1920 (9:16), in carousel order. */
export const volumeOnePages: VolumePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/eZVwH4rJVHe5QmSG9qKn4U/carrusel-01_vol1-p5.png',
    caption:
      'The Stacked Session Method: one theme, one page, every student in the group.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cnnSqGu8oCV3sELFZ9UJWh/carrusel-02_vol1-p10.png',
    caption: 'A short story and picture strip the whole group works from.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/f8i8FBKUPQpwAxKsoqnTto/carrusel-03_vol1-p12.png',
    caption:
      'The Target Grid: 4 rows (Sound, Word, Sentence, Social) × 3 levels.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9PUxVKt1bEZMwYomYg6SHR/carrusel-04_vol1-p26.png',
    caption:
      'Ready-to-run sessions built as games, with nothing to cut or laminate.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jNKzHjLRvXdGWfxPnF2caW/carrusel-05_vol1-p51.png',
    caption: 'Volume 1 at a glance: 6 themes, 12 sessions, 144 ready targets.',
  },
]
